/**
 * メインビジュアルの全画面表示
 */

// 関数の定義
function setHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// 初期化
setHeight();

// ブラウザのサイズが変更された時・画面の向きを変えた時に再計算する
window.addEventListener('resize', setHeight);


/**
 * メインビジュアルの画像切り替え
 */

$(function(){
    const $iframe01 = $('#js-main-visual01');
    const $iframe02 = $('#js-main-visual02');
    const $iframe03 = $('#js-main-visual03');
    const $iframe04 = $('#js-main-visual04');

    function changeImg() {
        setTimeout(function(){
            $iframe01.removeClass('is-show');
            $iframe02[0].contentDocument.location.reload();
        }, 6000);
        setTimeout(function(){
            $iframe02.addClass('is-show');
        }, 6100);
        setTimeout(function(){
            $iframe02.removeClass('is-show');
            $iframe03[0].contentDocument.location.reload();
        }, 12000);
        setTimeout(function(){
            $iframe03.addClass('is-show');
        }, 12100);
        setTimeout(function(){
            $iframe03.removeClass('is-show');
            $iframe04[0].contentDocument.location.reload();
        }, 18000);
        setTimeout(function(){
            $iframe04.addClass('is-show');
        }, 18100);
        setTimeout(function(){
            $iframe04.removeClass('is-show');
            $iframe01[0].contentDocument.location.reload();
        }, 24000);
        setTimeout(function(){
            $iframe01.addClass('is-show');
        }, 24100);
    }
    changeImg();
    setInterval(changeImg, 24000);
});


/**
 * ふわっとしたアニメーション
 */

$(function(){
    $(window).scroll(function(){
        const $elem = $('.js-anime');
        $elem.each(function(){
            const $elemOffset = $(this).offset().top;
            const $scrollPos = $(window).scrollTop();
            const $wh = $(window).height();
            if($scrollPos > $elemOffset - $wh*0.7){
                $(this).addClass('is-show');
            }
        });
    })
});


/**
 * 画面幅360px未満はviewportを固定
 */

(function () {
    const viewport = document.querySelector('meta[name="viewport"]');
    function switchViewport() {
        const value =
        window.outerWidth > 360
            ? 'width=device-width,initial-scale=1'
            : 'width=360';
        if (viewport.getAttribute('content') !== value) {
        viewport.setAttribute('content', value);
        }
    }
    addEventListener('resize', switchViewport, false);
    switchViewport();
})();
